<div class="layout-root">
  <!-- Mobile Overlay -->
  <div class="mobile-overlay" *ngIf="mobileSidebarOpen" (click)="closeMobileSidebar()"></div>

  <!-- Sidebar -->
  <app-sidebar
    [collapsed]="collapsed"
    (collapsedChange)="collapsed = $event"
    [mobileSidebarOpen]="mobileSidebarOpen"
    (mobileSidebarClose)="closeMobileSidebar()"
  ></app-sidebar>

  <!-- Floating sidebar collapse toggle (desktop) — sits on the sidebar's right edge, bottom -->
  <button
    type="button"
    class="sidebar-float-toggle desktop-only"
    [class.collapsed]="collapsed"
    (click)="toggleSidebar()"
    [attr.title]="collapsed ? 'Expand sidebar' : 'Collapse sidebar'"
    aria-label="Toggle sidebar"
  >
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round">
      <path *ngIf="!collapsed" d="m15 18-6-6 6-6"/>
      <path *ngIf="collapsed" d="m9 18 6-6-6-6"/>
    </svg>
  </button>

  <!-- MAIN CONTENT AREA -->
  <div class="main-area">

    <!-- ── TOP HEADER ──────────────────────────────────────────── -->
    <header class="top-header">

      <!-- LEFT: sidebar collapse toggle (desktop) + hamburger (mobile) -->
      <div class="header-left">
        <button class="mobile-menu-btn mobile-only" (click)="openMobileSidebar()" aria-label="Open menu">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
            stroke-linecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>

        <!-- Breadcrumbs -->
        <nav class="breadcrumb-nav" aria-label="Breadcrumb" *ngIf="breadcrumbs.length">
          <ol class="breadcrumb-list">
            <li class="breadcrumb-item" *ngFor="let crumb of breadcrumbs">
              <ng-container *ngIf="!crumb.isLast; else currentCrumb">
                <a class="breadcrumb-link" [routerLink]="crumb.url">{{ crumb.label }}</a>
                <span class="breadcrumb-separator" aria-hidden="true">/</span>
              </ng-container>
              <ng-template #currentCrumb>
                <span class="breadcrumb-current" aria-current="page">{{ crumb.label }}</span>
              </ng-template>
            </li>
          </ol>
        </nav>
      </div>

      <!-- RIGHT: role badge | bell | divider | avatar + name -->
      <div class="header-right">

        <!-- Role badge -->
        <span class="role-badge" *ngIf="userRoleLabel">{{ userRoleLabel }}</span>

        <!-- Notification bell -->
        <button class="action-btn" (click)="openNotificationDrawer()" title="Notifications" aria-label="Notifications">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
          </svg>
        </button>

        <!-- Divider -->
        <div class="header-divider"></div>

        <!-- Profile button + dropdown -->
        <div class="profile-wrapper">
          <!-- Click-outside backdrop -->
          <div *ngIf="isProfileMenuOpen" class="fixed inset-0 z-[60]" (click)="closeProfileMenu()"></div>

          <button class="profile-btn" (click)="toggleProfileMenu()" type="button"
            [attr.aria-label]="'Account menu for ' + (userName || 'User')"
            [attr.aria-expanded]="isProfileMenuOpen">
            <app-avatar [name]="userName" [avatarUrl]="avatarUrl()" [size]="'sm'" [border]="true"
              [borderColor]="'border-gray-200'" [borderWidth]="'border'"></app-avatar>
            <div class="profile-info desktop-only">
              <span class="profile-name">{{ userName || 'User' }}</span>
            </div>
            <svg class="profile-chevron desktop-only" [class.open]="isProfileMenuOpen" width="14" height="14"
              viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>

          <!-- Dropdown -->
          <div *ngIf="isProfileMenuOpen" class="profile-dropdown" (click)="$event.stopPropagation()">
            <!-- Header -->
            <div class="profile-dropdown-header">
              <app-avatar [name]="userName" [avatarUrl]="avatarUrl()" [size]="'md'" [border]="true"
                [borderColor]="'border-gray-200'" [borderWidth]="'border'"></app-avatar>
              <div class="overflow-hidden">
                <div class="dropdown-user-name">{{ userName || 'User' }}</div>
                <div class="dropdown-user-role">{{ userRoleLabel }}</div>
              </div>
            </div>

            <div class="dropdown-divider"></div>

            <a routerLink="/profile" class="dropdown-item" (click)="closeProfileMenu()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              Profile
            </a>

            <div class="dropdown-divider"></div>

            <button type="button" class="dropdown-item danger" (click)="openLogoutModal()">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              Sign out
            </button>
          </div>
        </div>

      </div>
    </header>

    <!-- CONTENT -->
    <main class="content-area">
      <router-outlet></router-outlet>
    </main>

  </div>
</div>

<!-- Logout Confirmation Modal -->
<app-confirmation-modal [isOpen]="showLogoutModal" [title]="'Confirm Logout'"
  [message]="'Are you sure you want to logout? You will need to login again to access your account.'"
  [confirmText]="'Logout'" [cancelText]="'Cancel'" [confirmButtonClass]="'btn-error'" [cancelButtonClass]="'btn-secondary'"
  (confirm)="confirmLogout()" (cancel)="closeLogoutModal()"></app-confirmation-modal>

<!-- Notification Drawer -->
<app-notification-drawer [isOpen]="showNotificationDrawer"
  (close)="closeNotificationDrawer()"></app-notification-drawer>

<!-- Telecaller Phone Verification Freeze Modal (non-closeable) -->
<app-telecaller-verification-modal [isOpen]="showVerificationModal" [exotelNumber]="verificationExotelNumber"
  [isChecking]="isCheckingVerification" [errorMessage]="verificationErrorMessage"
  (checkVerification)="onCheckVerification()"></app-telecaller-verification-modal>

<!-- Inactive Telecaller Account Freeze Modal (non-closeable, auto-logout) -->
<input type="checkbox" class="modal-state" [checked]="showInactiveAccountModal" />
<div class="modal" *ngIf="showInactiveAccountModal">
  <div class="modal-overlay"></div>
  <div class="modal-content flex flex-col gap-0 w-full max-w-md">
    <div class="modal-header flex items-center gap-3 px-6 py-4 border-b">
      <div class="w-10 h-10 bg-red-50 rounded-full flex items-center justify-center flex-shrink-0">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-red-500" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2">
          <path stroke-linecap="round" stroke-linejoin="round"
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
      </div>
      <h2 class="text-lg font-bold">Account Not Active</h2>
    </div>

    <div class="modal-body px-6 py-5 flex flex-col gap-3">
      <p class="text-sm text-gray-600">
        Your account is not active. Please contact your admin.
      </p>
      <p class="text-sm text-gray-500">
        You will be logged out in <strong>{{ inactiveAccountCountdown }}</strong> second{{ inactiveAccountCountdown ===
        1 ? '' : 's' }}.
      </p>
    </div>
  </div>
</div>